/**
 * «Клонировать вариант» — то, чем макет закрывает задачу «2-4 варианта за час»:
 * копия со всеми строками и материалами, дальше меняются один-два блока.
 */
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { TechCard } from '@/lib/planning/techCards';

export function CloneVariantDialog({
  card,
  saving,
  onSubmit,
  onClose,
}: {
  card: TechCard;
  saving: boolean;
  onSubmit: (name: string) => void;
  onClose: () => void;
}) {
  const [name, setName] = useState(`${card.name} — копия`);
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Клонировать вариант «{card.name}»</DialogTitle>
          <DialogDescription>
            Копия получит все операции варианта с материалами и нормами. Исходный вариант
            остаётся как был — сравнивать можно будет оба.
          </DialogDescription>
        </DialogHeader>
        <div>
          <Label htmlFor="tc-clone-name">Название нового варианта</Label>
          <Input
            id="tc-clone-name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
          />
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} disabled={saving}>
            Отмена
          </Button>
          <Button onClick={() => onSubmit(name)} disabled={saving || !name.trim()}>
            Клонировать
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
